import { Howl } from 'howler'

// html5: файлы лежат на домене API — HTML5 Audio не требует CORS, в отличие от Web Audio
export function createSound (url) {
  const sound = new Howl({ src: [url], html5: true })

  // Пока по странице не кликнули, браузер запрещает звук. Не теряем его, а доигрываем
  // при первом клике - один раз, сколько бы звуков ни запретили до этого
  sound.on('playerror', () => {
    sound.off('unlock')
    sound.once('unlock', () => sound.play())
  })

  return sound
}
